// Verifica se existe ao menos um erro de validacao.
export const hasValidationErrors = errors => {
	return Object.keys(errors || {}).length > 0;
};

// Remove da exibicao os erros dos campos que ja foram alterados pelo usuario.
export const removeClearedValidationErrors = ({
	errors = {},
	clearedErrors = {}
} = {}) => {
	return Object.entries(errors || {}).reduce((acc, [fieldName, message]) => {
		if (!clearedErrors[fieldName]) {
			acc[fieldName] = message;
		}

		return acc;
	}, {});
};